<div class="container-fluid">
  <div class="row m-2">
    <div class="col">
      <div class="row">
        <div class="col"></div>
        <div class="col-auto">
          <i
            (click)="close()"
            class="bi bi-x-lg x-icon-bold cursor-select fs-30"
          ></i>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label class="fs-24"
            >Terms & Conditions for Vendor Information Verification Experts, LLC
            (VIVE)</label
          >
        </div>
      </div>

      <div class="row row-padding">
        <div class="col">
          <div class="divider-bottom"></div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label class="bold">Introduction</label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <p>
            The Terms and Conditions written on this webpage shall manage your
            use of the VIVE public website and VIVE's private web portal
            accessible at
            <a href="https://app.getvived.com" target="_blank">GetVived.com</a>.
          </p>
          <p>
            These terms & conditions will be applied fully and affect your use
            of this website and web portal. By using this website and web
            portal, you agree to accept all terms and conditions written here.
            You must not use this website if you disagree with any of these
            Terms & Conditions.
          </p>
          <p>
            Minors or people below the age of 18 are not allowed to use this
            website.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label class="bold">What is this service?</label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <p>
            Services provided by VIVE facilitate the sharing of certain vendor
            information to VIVE's clients for whom the vendor provides various
            goods and/or services or with whom the vendor has another business
            relationship (such as association or a property management company
            by which you have been paid). This service provides a secure online
            registration portal wherein a vendor may submit insurance
            certificates, compliance paperwork and information for VIVE to
            review, scan, and host in a secure database. The database is a tool
            used by VIVE and VIVE's clients to facilitate the service. All
            submitted information by you, the vendor, will be reviewed by VIVE
            for completeness and for compliance with the client's terms. This
            service may also provide or involve data obtained from
            third-parties, such as sites utilized for verifying public database
            searches, trade & professional license verification, etc. VIVE makes
            no representation as to the accuracy or completeness of any
            third-party information utilized in facilitating this service.
          </p>
          <p>
            You, the vendor, grants VIVE the right, without any charge
            whatsoever, to collect, verify, store, and analyze compliance
            information relating to you, the vendor, and generate, use or
            distribute you, the vendor's, information to the VIVE Client.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label class="bold">Communication</label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <p>
            By creating your account with VIVE's web portal you agree that VIVE
            has the ability to communicate to you via email for the purposes of
            informing the user that certain actions have occurred, informing the
            user of necessary action(s) that needs to be addressed by the user,
            annual registration notices, etc. VIVE email notifications from the
            web portal are not solicitations and are essential to maintaining a
            direct line of communication with its users. Therefore, all active
            users of the VIVE web portal agree that the email notifications are
            unable to be stopped, nor does VIVE's web portal track and maintain
            an unsubscribe function.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label class="bold">Intellectual Property Rights</label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <p>
            Other than the content you own, under these Terms, VIVE and/or its
            licensors own all the intellectual property rights and materials
            contained in this Website.
          </p>
          <p>
            You are granted limited license only for the purposes of viewing the
            material contained on this Website.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label class="bold">Restrictions</label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <p>
            You, the vendor, are specifically restricted from all of the
            following:
          </p>
          <ul>
            <li>publishing any website material in any other media;</li>
            <li>
              selling, sublicensing and/or otherwise commercializing any website
              material;
            </li>
            <li>publicly performing and/or showing any website material;</li>
            <li>
              using this website in any way that is or may be damaging to this
              website;
            </li>
            <li>
              using this website in any way that impacts user access to this
              website;
            </li>
            <li>
              using this website contrary to applicable laws and regulations, or
              in any way may cause harm to the website, or to any person(s) or
              business entity;
            </li>
            <li>
              engaging in any data mining, data harvesting, data extracting or
              any other similar activity in relation to this website;
            </li>
            <li>
              using this website to engage in any advertising or marketing;
            </li>
            <li>
              Submitting or uploading illicit or pornographic content to VIVE's
              web portal.
            </li>
          </ul>
          <p>
            Certain areas of this website are restricted from being accessed by
            you and VIVE may further restrict access by you to any areas of this
            website, at any time, at VIVE's discretion. Any user ID and/or
            password you may have for this website are confidential and you must
            maintain confidentiality as well.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label class="bold">Your Content</label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <p>
            In these website Terms & Conditions, "Your Content" shall mean any
            audio, video, text, images, text data entry, certificates of
            insurance files, trade license files, business logos and/or other
            material you choose to enter, submit, upload to store and display in
            the web portal. By displaying your content, you grant VIVE a
            non-exclusive, worldwide, irrevocable, sub-licensable license to
            use, reproduce, adapt, publish, translate and distribute it in any
            and all media.
          </p>
          <p>
            Your content must be your own and must not be invading any
            third-party's rights. VIVE reserves the right to remove any of your
            content from this website at any time without notice.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label class="bold">No Refund Policy</label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <p>
            VIVE does not refund any fees for any reason. All fees paid by
            vendor and processed in the VIVE portal will be retained by VIVE in
            full.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label class="bold">No warranties</label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <p>
            This website is provided "as is", with all faults, and VIVE
            expresses no representations or warranties, of any kind related to
            this website or the materials contained on this website. Also,
            nothing contained on this website shall be interpreted as advising
            you.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label class="bold">Limitation of liability</label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <p>
            In no event shall VIVE, nor any of its officers, directors and/or
            employees, shall be held liable for anything arising out of or in
            any way connected with your use of this website whether such
            liability is under contract. VIVE, including its officers, directors
            and/or employees shall not be held liable for any indirect,
            consequential or special liability arising out of, or in any way
            related to, your use of this website.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label>Indemnification</label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <p>
            You hereby indemnify to the fullest extent VIVE from and against any
            and/or all liabilities, costs, demands, causes of action, damages
            and expenses arising in any way related to your breach of any of the
            provisions of these Terms.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label class="bold">Severability</label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <p>
            If any provision of these terms is found to be invalid under any
            applicable law, such provisions shall be deleted without affecting
            the remaining provisions herein.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label class="bold">Variation of Terms</label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <p>
            VIVE is permitted to revise these terms at any time as it sees fit,
            and by using this website you are expected to review these terms on
            a regular basis.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label class="bold">Assignment</label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <p>
            VIVE is allowed to assign, transfer, and subcontract its rights
            and/or obligations under these terms without any notification.
            However, you are not allowed to assign, transfer, or subcontract any
            of your rights and/or obligations under these terms.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label class="bold">Entire Agreement</label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <p>
            These terms constitute the entire agreement between VIVE and you in
            relation to your use of this website and web portal, and supersede
            all prior agreements and understandings.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label class="bold">Governing Laws & Jurisdiction</label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <p>
            These terms will be governed by and interpreted in accordance with
            the laws of the State of Michigan, United States of America, and you
            submit to the non-exclusive jurisdiction of the state and federal
            courts located in Michigan for the resolution of any disputes.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label class="bold">Privacy Policy</label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <p>
            This policy describes the ways we collect, store, use and protect
            your personal information. This policy is accepted when you sign up
            for our Service. This agreement between Vendor Information
            Verification Experts (“VIVE”) and you (the “Vendor”) sets forth the
            privacy statement terms and conditions of Vendor's participation in
            the VIVE Service (the “Service”) at the request of the Vendor or one
            or more third parties with which you have a relationship such as an
            association or management company by which you have paid (“Client”).
          </p>
          <p>
            We may amend this policy at any time by posting a revised version on
            our website. The revised version will be effective at the time we
            post it. In addition, if the revised version includes a substantial
            change, we will provide you with 30 days prior notice by posting
            notice of the change on the Policy Updates page of our website.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label class="bold">1. How we collect information about you</label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <p>
            Vendor participation is at the request of the vendor or one or more
            third parties with which you have a relationship such as an
            association or management company by which you have paid. The third
            party provides basic information on the business and business owner.
            In addition, when you visit
            <a href="https://www.getvived.com" target="_blank"
              >www.GetVIVED.com</a
            >
            we collect all information entered, your IP address and standard web
            log information, such as your browser type and the pages you
            accessed on our website.
          </p>
          <p>Examples of information we may collect from you:</p>
          <ul>
            <li>
              Company legal name, Company DBA, Company Structure, Company EIN or
              SSN, phone, address, website, fax.
            </li>
            <li>
              Owner name, title, address, phone, email, first 5 digits of SSN,
              date of birth, percent ownership
            </li>
            <li>
              Trade category and specialty, license information and status
            </li>
            <li>
              Insurance agent name, phone, email, Certificate of Liability
              Insurance
            </li>
          </ul>
          <p>
            When you are using our Service, we collect information about your
            account transactions and we may collect information about your
            computer or other access device for fraud prevention purposes.
          </p>
          <p>
            Finally, we may collect additional information from or about you in
            other ways not specifically described here. For example, we may
            collect information related to your contact with our customer
            support team or store results when you respond to a survey.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label class="bold">2. How we use cookies</label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <p>
            When you access our website, we may place small data files called
            cookies on your computer.
          </p>
          <p>
            We send a "session cookie" to your computer when you log in to your
            account. This type of cookie helps us to recognize you if you visit
            multiple pages on our site during the same session, so that we do
            not need to ask you for your password on each page. Once you log out
            or close your browser, this cookie expires and no longer has any
            effect.
          </p>
          <p>
            We do not store any longer-lasting cookies to display your e-mail
            address on our sign-in form.
          </p>
          <p>
            We encode our cookies so that only we can interpret the information
            stored in them. You are free to decline our cookies if your browser
            permits but doing so may interfere with your use of our website.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label class="bold"
            >3. How we protect and store personal information</label
          >
        </div>
      </div>

      <div class="row">
        <div class="col">
          <p>
            Throughout this policy, we use the term personal information to
            describe information that can be associated with a specific person
            and can be used to identify that person.
          </p>
          <p>
            We store and process your personal information on our computers in
            the US, and we protect it by maintaining physical, electronic and
            procedural safeguards in compliance with applicable US federal and
            state regulations. We use computer safeguards such as firewalls and
            data encryption, we enforce physical access controls to our
            buildings and files, and we authorize access to personal information
            only for those employees who require it to fulfill their job
            responsibilities.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label class="bold"
            >4. How we use the personal information we collect</label
          >
        </div>
      </div>

      <div class="row">
        <div class="col">
          <p>
            Our primary purpose in collecting personal information is to provide
            you with a safe, smooth, efficient, and customized experience. We
            may use your personal information to:
          </p>
          <ul>
            <li>provide the services and customer support you request;</li>
            <li>
              process transactions and send notices about your transactions
            </li>
            <li>resolve disputes, collect fees, and troubleshoot problems;</li>
            <li>
              prevent potentially prohibited or illegal activities, and enforce
              our Terms and Conditions;
            </li>
            <li>
              customize, measure, and improve our services and the content and
              layout of our website;
            </li>
            <li>
              send you targeted marketing, service update notices, and
              promotional offers based on your communication preferences;
            </li>
            <li>
              compare information for accuracy and verify it with third parties.
            </li>
          </ul>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label class="bold"
            >5. How we share personal information with other VIVE users</label
          >
        </div>
      </div>

      <div class="row">
        <div class="col">
          <p>
            To process your payments, we need to share some of your personal
            information with the VIVE client that you are registering for. Your
            contact information, date of sign-up, the number of payments you
            have received from verified VIVE customers.
          </p>
          <p>
            We work with merchants to enable them to accept payments from you
            using the VIVE web portal. In doing so, a merchant may share
            information about you with us, such as your email address, when you
            attempt to pay that merchant. We use this information to confirm to
            that merchant that you are a VIVE customer and that the merchant
            should enable VIVE as a form of payment for your purchase.
          </p>
          <p>
            Regardless, does not store or maintain credit records within the
            VIVE web portal, nor does VIVE disclose your credit card number or
            bank account numbers to anyone, except with your express permission
            or if we are required to do so to comply with a subpoena or other
            legal process.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label class="bold"
            >6. How we share personal information with other parties</label
          >
        </div>
      </div>

      <div class="row">
        <div class="col">
          <p>We may share your personal information with:</p>
          <ul>
            <li>
              Members of our corporate family to help detect and prevent
              potentially illegal acts, provide joint services and for other
              business purposes. However, these corporate affiliates will not
              use this information to market their services to you unless you
              have approved it.
            </li>
            <li>
              Service providers under contract who help with parts of our
              business operations; (fraud prevention, bill collection,
              marketing, technology services). Our contracts dictate that these
              service providers only use your information in connection with the
              services they perform for us and not for their own benefit.
            </li>
            <ul>
              <li>
                Companies that we plan to merge with or be acquired by. (Should
                such a combination occur, we will require that the new combined
                entity follow this privacy policy with respect to your personal
                information. If your personal information could be used contrary
                to this policy, you will receive prior notice.)
              </li>
            </ul>
            <li>
              Law enforcement, government officials, or other third parties
              when:
            </li>
            <ul>
              <li>
                we are compelled to do so by a subpoena, court order or similar
                legal procedure
              </li>
              <li>we need to do so to comply with law</li>
              <li>
                we believe in good faith that the disclosure of personal
                information is necessary to prevent physical harm or financial
                loss, to report suspected illegal activity, or to investigate
                violations of our Terms and Conditions.
              </li>
            </ul>
            <li>
              Other third parties with your consent or direction to do so.
            </li>
          </ul>
          <p>
            VIVE will not sell or rent any of your personal information to third
            parties in the normal course of doing business and only shares your
            personal information with third parties as described in this policy.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label class="bold"
            >7. How you can access or change your personal information</label
          >
        </div>
      </div>

      <div class="row">
        <div class="col">
          <p>
            You can review your personal information and make any necessary
            changes, at any time by logging in to your account and select the
            "Admin" option from the menu.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label class="bold"
            >8. How you can contact us about privacy questions</label
          >
        </div>
      </div>

      <div class="row row-padding-bottom">
        <div class="col">
          <p>
            If you have questions or concerns regarding this policy, you can
            contact us via email from the "Contact Us" option in the menu on our
            website,
            <a href="https://www.getvived.com" target="_blank">GetVIVED.com</a>
            or by writing to us at our corporate mailing address posted on our
            website,
            <a href="https://www.getvived.com" target="_blank">GetVIVED.com</a>
          </p>
        </div>
      </div>

      <form class="row">
        <div class="col">
          <div class="form-check">
            <label class="form-check-label my-0"
              >I have reviewed and agree to the Terms & Conditions outlined in
              the above document.<span class="required-field-asterisk"
                >*</span
              ></label
            >
          </div>
        </div>
      </form>

      <div class="row row-padding justify-content-center">
        <div class="col-4">
          <button class="btn btn-primary" (click)="confirm()">Confirm</button>
        </div>
      </div>
    </div>
  </div>
</div>
